import React, { useState, useEffect } from 'react';
import Carousel from '../Carousel/Carousel';
import './inicio.css';
import Boletines  from '../Boletines/Boletines';
import { presidenta } from '../../json/presidenta';
import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';
import { carouselImages } from '../../json/carouselImages';
//import { comunicadosCarrusel } from '../../json/comunicadosCarrusel';
//import ModalConvocatoria  from '../Modal/ModalConvocatoria';
import ReunionesTecnicas  from '../ReunionesTecnicas/ReunionesTecnicas';
import EventosDestacados  from '../EventosDestacados/EventosDestacados';
import { eventosDestacados } from '../../json/eventosDestacados';
import UltimasNoticias  from '../UltimasNoticias/UltimasNoticias';
import Comunicados  from '../Comunicados/Comunicados';
//import { ultimasNoticias } from '../../json/ultimasNoticias';


const Inicio = () => {

  const [isModalOpen, setModalOpen] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [show, setShow] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };


  return (
    <>

    {/*   {show ? (   --veda electoral  */}
  
    {/*  <div className='container'> --veda electoral */}

       <Carousel bannerData={carouselImages} serch={true} name={'banner-principal'}/>

       <div className='container'>  {/* Ocultar este div en veda electoral */}

        <div className='row'>
          <div className="col-12">
            <div className='secretaria_logo' style={{ padding: `40px` }}>
            {/* <div className='secretaria_logo_img' style={{ backgroundImage: `url("http://dif.hidalgo.gob.mx/img/DIF_LOGO-01.png")`}}></div>  */}
            <div className='secretaria_logo_img'>
                 <img src='http://dif.hidalgo.gob.mx/img/DIF_LOGO-01.png' style={{ width: `120px` }} /> </div> 
            </div>
            <div className='secretaria_name'>
              <h1>SISTEMA PARA EL DESARROLLO INTEGRAL DE LA FAMILIA DEL ESTADO DE HIDALGO</h1>
            </div>
            <div className='secretaria_funciones'>
              <h3 className='title'>FUNCIONES</h3>
              <hr className='hr-gob'/>
              <p>Desarrollar acciones en materia de asistencia social de manera corresponsable y en apego a lo establecido en las leyes y lineamientos aplicables a través de la ejecución de programas y proyectos encaminados al beneficio de las familias hidalguenses más vulnerables a fin de contribuir a su desarrollo humano y calidad de vida.</p>
                <div className='btn_organigrama'>
                  <button type="button" className="btn btn-primary">Organigrama</button>
                  <button type="button" className="btn btn-primary">Normatividad</button>
                </div>
                <div className='secretaria-redes'>
                  <a href=''><i className="fa-brands fa-facebook-f"></i></a>
                  <a href=''><i className="fa-brands fa-instagram"></i></a>
                  <a href=''><i className="fa-brands fa-twitter"></i></a>
                </div>
            </div>
          </div>
        </div>

        <br />
        <br />

        
        <div className='row'>
          <div className='notes_title'>
            <h3 className='title'>LO MÁS DESTACADO</h3>
            <hr className='hr-gob'/>
          </div>
          <br />
          {/* <h2 className="subTituloEventos">Festejando a las Madres Trabajadoras del Sistema DIF Hidalgo</h2> */}
          <br />
          <br />
          <br />
          <EventosDestacados/>

        {/*  <ReunionesTecnicas/>  */}

        {/*
          
          <div className="gallery">
          <Carousel bannerData={galeriaImagenes} serch={false} name={'banner-principal'}/>  
              <div className="gallery__item">
                <div className="gallery__thumb">
                {
                galeriaImagenes.map((item, index) =>(
                  <a href={ item.imagen } target="_blank" rel="noopener noreferrer">
                  <div key={ index } ><img id="imgMiniatura" src={ item.imagen } alt="" /></div> </a>
                  ))
                }
                </div>
              </div> 
          </div> */}

        </div>   
       {/* -------------------<Galeria/>------------------------- */}


        {/* ------    LISTADO DE BOLETINES DE PRENSA ----------- */}
    {/*    <div className='row'>
          <div className='notes_title'>
            <h3 className='title'>BOLETINES DE PRENSA</h3>
            <hr className='hr-gob'/>
          </div>
          <br />  

        <Boletines/> 

        </div> */}


      {/*
        <div className='row'>
          <div className='notes_title'>
            <h3 className='title'>BOLETINES DE PRENSA</h3>
            <hr className='hr-gob'/>
          </div>

           <div style={{ display: `flex`, width: `100%` }}>
              {
                 ultimasNoticias.map((item, index) =>(
                    <>
                       <div key={ index }>
                              <a href={ item.url } target="_blank" rel="noopener noreferrer">
                                 <h3>{ item.titulo }</h3>
                              </a>
                          
                          <div className='sec_function'>
                              <p>{ item.fecha }</p>
                            </div>
                            {
                              item.imagenes.map((img, index)=>(
                                  <div key={ index } style={{ display: `in-line block` }}>
                                      <a href={ img.imagen } target="_blank" rel="noopener noreferrer">
                                         <div  className='sec_photo'>
                                             <div className='img_secretario' style={{ backgroundImage: `url("${ img.imagen }")`, float: `left` }}></div> 
                                         </div>  
                                      </a>
                                  </div>    
                                ))
                            }
                      </div>
                    </>
                ))
              }
            </div>
          </div>
      }
*/}

      {/*  <UltimasNoticias/>  */}


        <br />
        <br />

        <div className='row'>
          <div className='notes_title'>
            <h3 className='title'>PRESIDENTA DEL PATRONATO</h3>
            <hr className='hr-gob'/>
          </div>
           <div className='section_notes'>
              {
                 presidenta.map((item, index) =>(
                    <>
                      <div key={ index } className='sec_photo'>
                        <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                        </div> 
                      </div>
                      <div className='sec_container'>
                        <div className='sec_name'>
                          <h3>{ item.nombre }</h3>
                        </div>
                        <div className='sec_function'>
                          <h4>Función de la Presidenta</h4>
                          <p>{ item.funcion }</p>

                      {/* <div className='btn_agenda'>
                            <Link to="Agenda">Conoce la agenda del Titular</Link>
                          </div>  */}

                        </div>
                      </div>
                    </>
                ))
              }
            </div>
          </div>

          <br />
          <br />

          <div className='row'>
          <div className='notes_title'>
            <h3 className='title'>TITULAR DEL SISTEMA DIF HIDALGO</h3>
            <hr className='hr-gob'/>
          </div>
          <div className='section_notes'>
            {
              titular.map((item, index) =>(
                  <>
                    <div key={ index } className='sec_photo'>
                      <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                      </div> 
                    </div>
                    <div className='sec_container'>
                      <div className='sec_name'>
                        <h3>{ item.nombre }</h3>
                      </div>
                      <div className='sec_function'>
                        <h4>Función del Titular</h4>
                        <p>{ item.funcion }</p>
                        <div className='btn_agenda'>
                          <Link to="Agenda">Conoce la agenda del Titular</Link>
                        </div>
                      </div>
                    </div>
                  </>
              ))
            }
          </div>
        </div>

        <br />
        <br />

      {/*  <ModalConvocatoria isOpen={isModalOpen} onClose={closeModal} /> */}


        

        <div className='row'>
          <div className='notes_title'>
            <h3 className='title'>NOTAS DE INTERÉS</h3>
            <hr className='hr-gob'/>
          </div>
          <br />
          <br />
          <UltimasNoticias/>
          <br />
          <br />
          
        </div>   
        
        <br />
        <br />

        {/*
        <div className='row'>
          <div className='notes_title'>
            <h3 className='title'>COMUNICADOS</h3>
            <hr className='hr-gob'/>
          </div>
          <br />
          <br />  
          <Comunicados/> 
          <br />
          <br />
        </div>    */}



        <div className='row'>
          <div className='section_map'>
            <div className='map_name'>
              <h3 className='title'>UBICACIÓN</h3>
              <hr className='hr-gob'/>
            </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3746.219512509504!2d-98.73628332407576!3d20.124887718207393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d109e59821eb17%3A0x2837ad178b8c73ba!2sSistema%20DIF%20Hidalgo!5e0!3m2!1ses!2smx!4v1684360066368!5m2!1ses!2smx" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                    width="100%" 
                    height="300" 
                    frameborder="0" 
                    style={{border:0, marginBottom:50}} 
                    allowfullscreen>
            </iframe>
          </div>
        </div>

    {/*  </div>  ) : (   veda electoral

      <div style={{ position: "fixed", height: "1000px", width: "100%", backgroundColor: "rgb(0,0,0,0.7)", zIndex: 1 }}>
        
          <div style={{ position: "fixed", height: "430px", width: "700px", marginLeft: "600px", marginTop: "200px", backgroundColor: "#FFF", padding: "40px", borderRadius: "15px", zIndex: 2 }}>
            
            <div className='close-icon'>
                <button type="button" className="btn btn-primary" onClick={() => { setShow(!show); }}><i className="fa-sharp fa-solid fa-xmark"/></button>
            </div>

            <h5 style={{ textAlign: "center", color: "darkblue", fontWeight: "bold"}}>AVISO A LA CIUDADANÍA GENERAL</h5>
            <br />
            <div style={{ display: "inline"}}>
              <p className='agenda-title'>Con fundamento en el Artículo 41, base III, apartado C, párrafo segundo y 134 párrafo octavo de la Constitución Política
               de los Estados Unidos Mexicanos; Artículo 209 número 1 de la Ley General de Instituciones y Procedimientos Electorales; Artículo 24, base II, párrafo
               noveno de la Constitución Política de Hidalgo y Artículo 126, párrafo tercero del Código Electoral del Estado de Hidalgo, se informa a la ciudadanía
               que algunas secciones de este portal de internet quedarán suspendidas durante el tiempo que comprenden el <p style={{ color: "darkblue", fontWeight: "bold"}}>
               "PROCESO ELECTORAL LOCAL DE DIPUTACIONES Y AYUNTAMIENTOS CONCURRENTE CON EL FEDERAL 2023-2024"</p> Hasta la conclusión de la respectiva jornada comicial 
               (del 1 de marzo, hasta el 2 de junio de 2024).</p>
          </div>
          </div>
        </div> 
      )} */}
    </div> 

    </>
  )
}

export default Inicio